export default {
  data() {
    return {
      submitMethod: null,
      entityChanged: false,
      options: {
        okText: 'Submit and leave',
        cancelText: 'Leave without submitting',
        // backdropClose: true,
      },
      message: {
        title: 'Hold on!',
        body: 'You are leaving this page without submitting your changes.',
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.interval) clearInterval(this.interval);
    if (this.entityChanged) {
      this.$dialog
        .confirm(this.message, this.options)
        .then(() => {
          next(false);
          this.submitMethod(next);
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  },
  methods: {
    initBeforeLeave(changed, method) {
      this.entityChanged = changed;
      this.submitMethod = method;
    },
    setUnchanged() {
      this.entityChanged = false;
    },
  },
};
